export default __webpack_public_path__ + "static/media/Forum.2e8783d4.svg";